import React from 'react';
import { Button, Col, DatePicker, Dropdown, Menu, Row, Select } from 'antd';
import {
  DownloadOutlined,
  FileTextOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { REPORT_TYPE } from '../../../constants';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ReportHeader = ({
  dateRanger,
  changeDateRanger,
  handleDateRangerChange,
  handleDownloadReportAccountCamera,
  handleExportPdf,
  isLoadingExportAccountCamera,
  isLoadingExportStorageCamera,
  isLoadingExportGatewayCamera,
  isLoadingExportGatewayCameraInfo,
}) => {
  const { t } = useTranslation();

  const getSelectedOption = () => {
    if (!dateRanger || dateRanger.length !== 2) return undefined;
    const start = moment(dateRanger[0]).startOf('day');
    const end = moment(dateRanger[1]).startOf('day');
    const diffDays = end.diff(start, 'days') + 1;

    if (diffDays === 1) return 1;
    if (diffDays === 3) return 3;
    if (diffDays === 7) return 7;
    if (diffDays >= 28 && diffDays <= 31) return 30;
    return undefined;
  };

  return (
    <Row style={{ marginBottom: 10, padding: '0px 20px' }}>
      <Col span={12} className="input_date_picker">
        <Select
          // placeholder="Select number of days"
          style={{ width: 130 }}
          value={getSelectedOption()}
          onChange={(value) => value && changeDateRanger(value)}
        >
          {/* <Option value={1}>{t('Today')}</Option> */}
          <Option value={3}>{t('3 days')}</Option>
          <Option value={7}>{t('7 days')}</Option>
          <Option value={30}>{t('30 days')}</Option>
        </Select>
        <RangePicker
          defaultValue={[
            moment()
              .subtract({ days: 2 })
              .set({ hour: 0, minute: 0, second: 0 }),
            moment().set({ hour: 23, minute: 59, second: 59 }),
          ]}
          value={
            dateRanger && dateRanger.length === 2
              ? [moment(dateRanger[0]), moment(dateRanger[1])]
              : []
          }
          onChange={handleDateRangerChange}
        />
      </Col>
      <Col span={12}>
        <Row justify="end" gutter={[8, 8]}>
          <Col>
            <div className="edit-button" title={t('Report')}>
              <Dropdown
                trigger={['click']}
                placement="bottomRight"
                overlay={
                  <Menu>
                    <Menu.Item
                      key="0"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_ACCOUNT,
                        )
                      }
                      disabled={isLoadingExportAccountCamera}
                    >
                      {isLoadingExportAccountCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>{t('Report account camera')}</span>
                    </Menu.Item>
                    <Menu.Item
                      key="1"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_STORAGE,
                        )
                      }
                      disabled={isLoadingExportStorageCamera}
                    >
                      {isLoadingExportStorageCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>{t('Report storage camera')}</span>
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_GATEWAY,
                        )
                      }
                      disabled={isLoadingExportGatewayCamera}
                    >
                      {isLoadingExportGatewayCamera ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>{t('Report camera/gateway information')}</span>
                    </Menu.Item>
                    <Menu.Item
                      key="3"
                      onClick={() =>
                        handleDownloadReportAccountCamera(
                          REPORT_TYPE.REPORT_GATEWAY_INFO,
                        )
                      }
                      disabled={isLoadingExportGatewayCameraInfo}
                    >
                      {isLoadingExportGatewayCameraInfo ? (
                        <span>
                          <LoadingOutlined />
                        </span>
                      ) : (
                        <span>
                          <DownloadOutlined />
                        </span>
                      )}
                      <span>{t('Report gateway information')}</span>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Button icon={<FileTextOutlined />}>{t('Report')}</Button>
              </Dropdown>
            </div>
          </Col>

          <Col className="export-button">
            <Button onClick={handleExportPdf}>{t('Export')}</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ReportHeader;
